import React from "react";

import { useAudio } from "./AudioContext";

export default function Timeline() {
  const { playAudio, playHover, pauseHover } = useAudio();

  const handleClick = () => {
    playAudio();
  };

  const handleMouseEnter = () => {
    playHover(0.3);
  };

  const handleMouseLeave = () => {
    pauseHover();
  };

  return (
    <div>
      <div className="time-line">
        <div className="circle">
          <span>Let's Start</span>
        </div>
        <div className="line"></div>

        <a
          href="#works"
          onClick={handleClick}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className="scroll-mouse">
            <i className="fi fi-rr-mouse"></i>
            <h4>SCROLL</h4>
          </div>
        </a>

        <div className="line line2"></div>
        <div className="circle">
          <span>Works</span>
        </div>
        <div className="line works-line"></div>
        <div className="circle">
          <span>Skills</span>
        </div>
        <div className="line skills-line"></div>
        <div className="circle">
          <span>Experience</span>
        </div>
        <div className="line experience-line"></div>
        <div className="circle">
          <span>Resume</span>
        </div>
        <div className="line resume-line"></div>
        <div className="circle">
          <span>Milestones</span>
        </div>
        <div className="line milestones-line"></div>
        <div className="circle">
          <span>Contact</span>
        </div>
        <div className="line contact-line"></div>
      </div>
    </div>
  );
}
